import React from 'react'
import { Text, View } from 'react-native'

import {
  B1,
  B2,
  Icon,
  Input,
  SH3,
  Stack,
  XStack,
  colors as zetColors,
} from '@zet/design-system'

const MobileInput = ({
  label,
  placeholder,
  onChange = () => null,
  onBlur,
  value,
  isRequired = true,
  isEditable,
  iconLeft,
  iconRight,
  className,
  disabled,
  inputMode,
  config,
  noDisabledStyle,
  errorMessage,
  countryCode,
}) => {
  return (
    <Stack>
      <B2 className="text-grays-80 mb-1">
        {label} {isRequired ? <B1 className="text-error-100 ml-1">*</B1> : null}
      </B2>
      <XStack
        className={`
        border-grays-40 flex-row items-stretch overflow-hidden rounded-md border px-2 py-[12px]
        ${disabled && !noDisabledStyle ? 'bg-grays-30' : ''}
        ${errorMessage ? 'border-error-100' : ''}
      `}
      >
        <SH3 className="text-grays-80 border-grays-40 self-center border-r-[1px] px-2">
          {countryCode}
        </SH3>
        <XStack className="w-full flex-1 flex-row items-center">
          <Input
            placeholder={placeholder}
            onBlur={onBlur}
            onChangeText={(value) => {
              if (value.length <= 10) onChange(value)
            }}
            className={`
             m-0 h-full flex-1 border-0 bg-black bg-transparent px-0 pl-2 outline-none
              ${className || ''}
            `}
            value={value}
            showErrorText={false}
            stylingOverrides={{ parentClassname: 'w-full ' }}
            intent={errorMessage ? 'error' : 'primary'}
            type={errorMessage ? 'error' : 'primary'}
            isEditable={isEditable}
            iconLeft={iconLeft}
            style={{ paddingLeft: 8, paddingVertical: 0 }}
            inputMode={inputMode}
            keyboardType={'number-pad'}
            iconRight={
              errorMessage ? (
                <View className="relative top-1 mr-1">
                  <Icon
                    color={zetColors.error[100]}
                    type="ErrorOutlined"
                    size={28}
                  />
                </View>
              ) : (
                iconRight
              )
            }
            noIconPadding={true}
            disabled={disabled}
            maxLength={config?.maxLength || undefined}
          />
        </XStack>
      </XStack>
      {errorMessage && <ErrorText intent="error">{errorMessage}</ErrorText>}
    </Stack>
  )
}

const ErrorText = ({ children, intent }) => (
  <Text
    className={`
    pt-2 text-xs font-normal leading-4
    ${intent === 'error' ? 'text-error-100' : 'text-grays-60'}
  `}
  >
    {children}
  </Text>
)

export default MobileInput
